<template>
  <form class="personal-info-form">
    <div class="personal-info-form__names">
      <Input
        :id="`${idPrefix}-first-name`"
        :label="$t('components.form.firstName')"
        type="text"
        autocomplete="given-name"
        v-model="user.first_name"
        @blur="emitUser"
        :aria-label="$t('components.form.firstName')"
        :placeholder="$t('components.form.firstName')"
        class="personal-info-form__input"
        :internalLabel="true"
      />
      <Input
        :id="`${idPrefix}-last-name`"
        :label="$t('components.form.lastName')"
        type="text"
        autocomplete="family-name"
        v-model="user.last_name"
        @blur="emitUser"
        :aria-label="$t('components.form.lastName')"
        :placeholder="$t('components.form.lastName')"
        class="personal-info-form__input"
        :internalLabel="true"
      />
    </div>
    <Input
      :id="`${idPrefix}-email`"
      :label="$t('components.form.email')"
      type="text"
      autocomplete="email"
      v-model="user.email"
      @blur="emitUser"
      :aria-label="$t('components.form.email')"
      :placeholder="$t('components.form.email')"
      :internalLabel="true"
    />
    <Input
      :id="`${idPrefix}-phone`"
      :label="$t('components.form.phone')"
      autocomplete="tel"
      type="text"
      v-model="user.phone_number"
      @blur="emitUser"
      :aria-label="$t('components.form.phone')"
      :placeholder="$t('components.form.phone')"
      :internalLabel="true"
    />
  </form>
</template>

<script lang="ts">
  import { defineComponent, ref, watch, PropType } from 'vue'
  import Input from './Input.vue'

  interface User {
    first_name: string
    last_name: string
    email: string
    phone_number: string
  }

  export default defineComponent({
    name: 'PersonalInfoForm',
    components: {
      Input,
    },
    props: {
      idPrefix: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      user: {
        type: Object as PropType<User>,
        required: true,
        default: () => ({
          first_name: '',
          last_name: '',
          email: '',
          phone_number: ''
        }),
      },
    },
    emits: ['update:user'],
    setup(props, { emit }) {
      const user = ref<User>({
        first_name: props.user.first_name || '',
        last_name: props.user.last_name || '',
        email: props.user.email || '',
        phone_number: props.user.phone_number || ''
      })

      const emitUser = () => {
        emit('update:user', { ...user.value })
      }

      watch(
        () => props.user,
        (newUser) => {
          if (newUser) {
            user.value = {
              first_name: newUser.first_name || '',
              last_name: newUser.last_name || '',
              email: newUser.email || '',
              phone_number: newUser.phone_number || ''
            }
          }
        },
        { immediate: true, deep: true }
      )

      return {
        user,
        emitUser
      }
    },
  })
</script>

<style lang="scss" scoped>
  .personal-info-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    container-type: inline-size;

    &__names {
      display: flex;
      flex-direction: column;
      gap: 20px;

      @container (min-width: 560px) {
        flex-direction: row;
      }

      > .input {
        flex-basis: 50%;
      }
    }
  }
</style>
